import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propShape, propStr, propChildren, propBool, } from '../../../../helpers/custom-prop-types';
import InputError from '../../Common/InputError';
import PlainInput from '../../Common/PlainInput';
const RfpTextField = (props) => {
    const { description, disabled, input, isOptional, isRequired, label, meta, placeholder, type, } = props;
    return (_jsxs("div", Object.assign({ className: 'field' }, { children: [_jsxs("label", { children: [label && (_jsxs("div", Object.assign({ className: 'label' }, { children: [label, isRequired && _jsx("span", Object.assign({ className: 'req' }, { children: "\u5FC5\u9808" })), isOptional && _jsx("span", Object.assign({ className: 'any' }, { children: "\u4EFB\u610F" }))] }))), _jsx("div", Object.assign({ className: 'input_content' }, { children: _jsx(PlainInput, { className: 'input-form-text', disabled: disabled, id: input.name, input: input, meta: meta, placeholder: placeholder, type: type }) })), _jsx(InputError, { meta: meta })] }), description] })));
};
RfpTextField.propTypes = {
    description: propChildren(),
    disabled: propBool(),
    input: propShape().isRequired,
    isOptional: propBool(),
    isRequired: propBool(),
    label: propStr(),
    meta: propShape().isRequired,
    placeholder: propStr(),
    type: propStr().isRequired,
};
RfpTextField.defaultProps = {
    description: null,
    disabled: false,
    isOptional: false,
    isRequired: true,
    label: '',
    placeholder: '',
};
export default RfpTextField;
